import type { DirectionDxDy } from "./DirectionDxDy.type"

export const DIRECTION_DXDY_SOUTH = { dx: 0, dy: 1 }
export const DIRECTION_DXDY_EAST = { dx: 1, dy: 0 }
export const DIRECTION_DXDY_NORTH = { dx: 0, dy: -1 }
export const DIRECTION_DXDY_WEST = { dx: -1, dy: 0 }


export const dijkstraDirections: ReadonlyArray<DirectionDxDy> = [
  DIRECTION_DXDY_SOUTH,
  DIRECTION_DXDY_EAST,
  DIRECTION_DXDY_NORTH,
  DIRECTION_DXDY_WEST,
] as const
